import { forwardRef } from 'react';

import palette from '@lib/core/src/theme/palette';
import { styled } from '@mui/material';

const DoughnutContainer = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: 57.2,
  height: 57.2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  background: palette.grey[2400],
  borderRadius: '50%',
  '&:hover': {
    scale: 1.1
  },
  boxShadow:
    '0px 19.8px 96.8px -4.4px rgba(24, 39, 75, 0.14), 0px 8.8px 30.8px -6.6px rgba(24, 39, 75, 0.12)'
});

const DoughnutText = styled('div')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  fontFamily: 'Reddit Sans, sans-serif',
  fontWeight: 600,
  fontSize: 14.3,
  color: palette.black,
  textAlign: 'center'
});

interface DoughnutProps {
  percent?: number;
  onClick?: () => void;
}

const Doughnut = forwardRef<HTMLDivElement, DoughnutProps>(({ percent = 0, onClick }, ref) => {
  const radius = 26.4;
  const circumference = 2 * Math.PI * radius;
  const progress = (percent / 100) * circumference;

  return (
    <DoughnutContainer ref={ref} onClick={onClick}>
      <svg width="57.2" height="57.2">
        <circle
          cx="28.6"
          cy="28.6"
          r="26.4"
          fill={palette.grey[2400]}
          stroke={palette.green[600]}
          strokeWidth="4.4"
          opacity="0.15"
        />
        <circle
          cx="28.6"
          cy="28.6"
          r="26.4"
          fill="none"
          stroke={palette.green[600]}
          strokeWidth="4.4"
          strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 0.5s' }}
          transform="rotate(-90 28.6 28.6)"
        />
      </svg>
      <DoughnutText>{percent}%</DoughnutText>
    </DoughnutContainer>
  );
});

export default Doughnut;
